var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.getUserData)?_c('TheSidebar'):_vm._e(),_c('div',{staticClass:"c-wrapper"},[_c('div',{ref:"cbody",staticClass:"c-body",attrs:{"id":"c-body-app"}},[_c('main',{staticClass:"c-main"},[_c('CContainer',{attrs:{"fluid":""}},[_c('transition',{attrs:{"name":"fade"}},[_c('router-view')],1)],1)],1)])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }